import axios from 'axios';
// let url = 'http://13.235.89.155/api/v1/';
// let url = 'http://13.235.89.155:8080/api/v1/';
// let url = 'http://102.133.168.113:8778/api/v1/';

//let url = 'http://134.122.16.97:7779/api/v1/'; //staging

// let url = 'http://197.242.159.203:8778/api/v1/'; //client-test-staging
// let url = 'https://smartvisitor-api.staging9.com/api/v1/'; // right api
//let url = 'http://192.168.9.172:8080/api/v1/';

//let url = 'https://api.smartvisitor.co.za:8778/api/v1/'; //production

let url = 'http://smartvisitor.co.za/admin/api/v1/'; //production right api

const HTTP = axios.create({
    baseURL: `${url}`,
    headers: {
        "Content-Type": "application/json",
    }
});

axios.defaults.baseURL = `${url}`;

export const login = ({commit}, data) => {
    commit('setLoading', true);
    return HTTP.post('login/',
            data, {}).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

export const createCompany = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/company/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const companyList = ({commit, getters}, data) => {
    commit('setLoading', true);

    return HTTP.get('list/company/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteCompany = ({commit, getters}, data) => {

    commit('setLoading', true);
    return HTTP.delete(`delete/company/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const editCompany = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`view/company/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateCompany = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.put(`update/company/` + data.id + `/`,
            data.formData, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

export const questionList = ({commit, getters}, data) => {
    commit('setLoading', true);

    return HTTP.get('list/questions/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};
export const createQuestion = ({commit, getters}, data) => {

    commit('setLoading', true);
    return HTTP.post('create/question/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteQuestion = ({commit, getters}, data) => {

    commit('setLoading', true);
    return HTTP.delete(`delete/question/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const editQuestion = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`view/question/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateQuestion = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.put(`update/question/` + data.id + `/`,
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const questionnairesList = ({commit, getters}, data) => {
    commit('setLoading', true);

    return HTTP.get('list/questionnaires/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

export const siteQuestionnairesList = ({commit, getters}, data) => {
    commit('setLoading', true);

    return HTTP.get('list/questionnaires/site/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const createQuestionnaires = ({commit, getters}, data) => {

    commit('setLoading', true);
    return HTTP.post('create/questionnaire/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const editQuestionnaires = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`view/questionnaire/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateQuestionnaires = ({commit, getters}, data) => {
    commit('setLoading', true);
    let id = data.id;
    delete data.id;
    return HTTP.put(`update/questionnaire/` + id + `/`,
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteQuestionnaires = ({commit, getters}, data) => {

    commit('setLoading', true);
    return HTTP.delete(`delete/questionnaire/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

// export const logout = ({commit, getters}) => {
//     commit('setLoading', true);

//     return HTTP.post('logout', {}, {
//         headers: {
//             Authorization: `Bearer ` + getters.login.token
//         }
//     }).then((response) => {
//         commit('clearLogin');
//         commit('setLoading', false);
//         commit('setUnauthorized', false);
//         return response;
//     }, (err) => {
//         if (err.response.status == 401) {
//             commit('clearLogin');
//             commit('setUnauthorized', true);
//             return err.response;
//         }
//         commit('setLoading', false);
//         return err.response;
//     });
// };

/* SITE MANAGEMENT */

export const siteList = ({commit, getters}) => {
    commit('setLoading', true);
    return HTTP.get('list/company/sites/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const addSite = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/company/site/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateSite = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.put('update/company/site/' + data.id + '/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteSite = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.delete('delete/company/site/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const viewSite = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.get('view/company/site/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

export const listOfWorkTypeWithDocument = ({commit, getters}) => {
    commit('setLoading', true);
    return HTTP.get('list/work/type/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const addWorkTypeWithDocument = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/work/type/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateWorkTypeWithDocument = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.put('update/work/type/' + data.id + '/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteWorkTypeWithDocument = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.delete('delete/work/type/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};


export const listOfDepartments = ({commit, getters},id) => {
    commit('setLoading', true);
    return HTTP.get('list/site/departments/'+id+'/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const addDepartment = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/department/',
            data.data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateDepartment= ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.put('update/department/' + data.id + '/',
            data.data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteDepartment = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.delete('delete/department/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
/* ASSIGN QUESTIONNAIRES TO THE SITE  */
export const listSiteQuestionnaires = ({commit, getters}) => {
    commit('setLoading', true);
    return HTTP.get('list/site/questionnaires/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};
export const addQuestionnaire = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/site/questionnaire/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateQuestionnaire = ({commit, getters}, data) => {
    commit('setLoading', true);
    let id = data.id;
    delete data.id;
    return HTTP.put('update/site/questionnaire/' + id + '/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        } else {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteSiteQuestionnaire = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.delete('delete/site/questionnaire/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const viewQuestionnaire = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.get('view/site/questionnaire/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

/* QUESTIONNAIRE QUESTIONS */

export const questionnaireQuestions = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.get('list/questionnaire/questions/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};
export const CUDQuestionnaireQuestion = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('cud/questionnaire/question/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

/* COMPANY SITES */

export const getSites = ({commit, getters}) => {
    commit('setLoading', true);
    return HTTP.get('list/company/sites/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

/* VISITOR */

export const signUp = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/visitor/',
            data, {}).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

export const fetchDocuments = ({ commit }, params) => {
    commit('setLoading', true);
    return HTTP.get('list/document/type/', { params })
      .then((response) => {
        if (response.status === 200) {
          commit('setDocuments', response.data); // Update documents in the store
          return response;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          commit('setUnauthorized', true); // Update unauthorized state
        }
        return err.response;
      })
      .finally(() => {
        commit('setLoading', false); // Ensure loading state is updated
      });
};
export const postDocument = ({ commit,getters }, payload) => {
    commit('setLoading', true);
    return HTTP.post('create/document/type/', 
        payload, {
            headers: {
                Authorization: `JWT ` + getters.login.token
            }
        })
      .then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};
export const updateDocument = ({ commit,getters }, data) => {
    commit('setLoading', true);
    return HTTP.put('update/document/type/' + data.id + `/`,
        data, {
            headers: {
                Authorization: `JWT ` + getters.login.token
            }
        }).then((response) => {
    if (response.status === 200) {
        commit('setLoading', false);
        commit('setUnauthorized', false);
        return response;
    }
}, (err) => {
    commit('setLoading', false);
    if (err.response.status == 401) {
        commit('setUnauthorized', true);
    }
    return err.response;
}).catch(reason => {
    return reason;
});
};
export const editDocument = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`get/document/type/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteDocument = ({commit, getters}, id) => {

    commit('setLoading', true);
    return HTTP.delete(`delete/document/type/` + id + '/',
        {
            headers: {
                Authorization: `JWT ` + getters.login.token
            }
        }).then((response) => {
    if (response.status === 200) {
        commit('setLoading', false);
        commit('setUnauthorized', false);
        return response;
    }
}, (err) => {
    commit('setLoading', false);
    if (err.response.status == 401) {
        commit('setUnauthorized', true);
    }
    return err.response;
}).catch(reason => {
    return reason;
});
};

export const viewDocumnetsOfUser = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.get('visitor/uploads/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteUploadedDocument = ({commit, getters}, id) => {

    commit('setLoading', true);
    return HTTP.delete(`delete/visitor/uploads/` + id + '/',
        {
            headers: {
                Authorization: `JWT ` + getters.login.token
            }
        }).then((response) => {
    if (response.status === 200) {
        commit('setLoading', false);
        commit('setUnauthorized', false);
        return response;
    }
}, (err) => {
    commit('setLoading', false);
    if (err.response.status == 401) {
        commit('setUnauthorized', true);
    }
    return err.response;
}).catch(reason => {
    return reason;
});
};
export const fetchUsersDocuments = ({ commit }, params) => {
    commit('setLoading', true);
    return HTTP.get('list/visitor/uploads/', { params })
      .then((response) => {
        if (response.status === 200) {
          commit('setDocuments', response.data); // Update documents in the store
          return response;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          commit('setUnauthorized', true); // Update unauthorized state
        }
        return err.response;
      })
      .finally(() => {
        commit('setLoading', false); // Ensure loading state is updated
      });
};
export const postDocumentForUser = ({ commit,getters }, payload) => {
    commit('setLoading', true);
    return HTTP.post('create/visitor/uploads/',
        payload.data, {
            headers: {
                Authorization: `JWT ` + getters.login.token
            }
        })
      .then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
}; 
export const updateDocumentForUser = ({ commit,getters }, payload) => {
    commit('setLoading', true);
    return HTTP.put('update/visitor/uploads/'+ payload.id + '/',
        payload.data, {
            headers: {
                Authorization: `JWT ` + getters.login.token
            }
        })
      .then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
}; 
export const listOfDocumentsOfUser = ({commit, getters}) => {
    commit('setLoading', true);
    return HTTP.get('visitor/uploads/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
}; 

export const visitorQuestionForm = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('visitor/form/submit/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const getVisitor = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`get/visitor/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

export const listOfApprovers = ({ commit,getters }) => {
    commit('setLoading', true);
    return HTTP.get('list/approvers/',
        {
            headers: {
                Authorization: `JWT ` + getters.login.token
            }
        }).then((response) => {
    if (response.status === 200) {
        commit('setLoading', false);
        commit('setUnauthorized', false);
        return response.data;
    }
}, (err) => {
    commit('setLoading', false);
    if (err.response.status == 401) {
        commit('setUnauthorized', true);
    }
    return err.response.data;
}).catch(reason => {
    return reason;
});
};
/* USERS */

export const userList = ({commit, getters}) => {
    commit('setLoading', true);
    return HTTP.get('list/system/users/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

// Device Management
export const deviceList = ({commit, getters}, data) => {
    commit('setLoading', true);

    return HTTP.get('list/company/site/devices/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};
export const createDevice = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/company/site/device/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const editDevice = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`view/company/site/device/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateDevice = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.put(`update/company/site/device/` + data.id + `/`,
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteDevice = ({commit, getters}, data) => {

    commit('setLoading', true);
    return HTTP.delete(`delete/company/site/device/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

// user management

export const systemUserList = ({commit, getters}) => {
    commit('setLoading', true);

    return HTTP.get('list/system/users/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};
export const createSystemUser = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/system/user/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteSystemUser = ({commit, getters}, id) => {

    commit('setLoading', true);
    return HTTP.delete('delete/system/user/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const editSystemUser = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`view/system/user/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateSystemUser = ({commit, getters}, data) => {
    commit('setLoading', true);
    let id = data.id;
    delete data.id;
    return HTTP.put(`update/system/user/` + id + `/`,
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
// visitor-request-approval

export const visitorFormsList = ({commit, getters}, data) => {
    commit('setLoading', true);

    return HTTP.get('list/visitor/forms/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const visitorForm = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.get('visitor/form' + id + "/",
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const viewVisitorForms = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`view/visitor/form/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);

        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

// Company Visitor Request List

export const companyVisitorFormsList = ({commit, getters}, data) => {
    commit('setLoading', true);
    // return HTTP.get('list/company/visitor/forms/',
    return HTTP.post('list/company/visitor/forms/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

// Company Visitor Request View

export const viewCompanyVisitorForms = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`view/company/visitor/form/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);

        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
// update company visitor request Apporval
export const updateCompanyVisitor = ({commit, getters}, data) => {
    commit('setLoading', true);

    return HTTP.put(`update/company/visitor/form/` + data.id + `/`,
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

// report ()
export const getReport = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('get/report/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};


export const getSiteUponCompany = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`list/sites/from/company/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

// visitor-form data
export const VisitorForm = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get(`visitor/form/` + data + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};

// visitors list
export const visitorsList = ({commit, getters}) => {
    commit('setLoading', true);
    return HTTP.get('list/visitors/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};
export const visitorGroupList = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.get('list/visitor/groups/' + data.ID + "/",
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                },
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const addVisitorGroup = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/visitor/group/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const reRouteApi = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('reroute/company/visitor/form/'+data.id+'/',
            data.department, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const viewGroup = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.get('view/visitor/group/' + id + '/',
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const updateGroup = ({commit, getters}, data) => {
    commit('setLoading', true);
    let id = data.groupID;
    delete data.groupID;
    return HTTP.put('update/visitor/group/' + id + '/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteVisitorGroup = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.delete(`delete/visitor/group/` + id + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const addGroupMember = ({commit, getters}, data) => {
    commit('setLoading', true);
    return HTTP.post('create/visitor/group/member/',
            data, {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
export const deleteVisitor = ({commit, getters}, id) => {
    commit('setLoading', true);
    return HTTP.delete(`delete/visitor/group/member/` + id + `/`,
            {
                headers: {
                    Authorization: `JWT ` + getters.login.token
                }
            }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        return reason;
    });
};
